export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>
      }
    : T

export type UnknownObject = Record<string, unknown>

export const isObject = (value: unknown) =>
    typeof value === 'object' && value !== null && !Array.isArray(value)

export function deepMergeObjects<T extends UnknownObject>(
    defaults: DeepPartial<T>,
    overrides: Partial<T>
): T {
    const result: any = { ...defaults }

    for (const key in overrides) {
        const defaultValue = defaults[key],
            overrideValue = overrides[key]

        const isDefaultObject = isObject(defaultValue),
            isOverrideObject = isObject(overrideValue)

        if (isDefaultObject && isOverrideObject) {
            result[key] = deepMergeObjects(
                defaultValue as UnknownObject,
                overrideValue as UnknownObject
            )
        } else if (overrideValue !== undefined) {
            result[key] = overrideValue
        }
    }

    return result
}
